"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactForm = require("react-form");

var _Button = _interopRequireDefault(require("../Button"));

var SubmitButton = function SubmitButton(_ref) {
  var disabled = _ref.disabled,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["disabled"]);

  var _useFormContext = (0, _reactForm.useFormContext)(),
      canSubmit = _useFormContext.meta.canSubmit;

  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, restProps, {
    type: "submit",
    disabled: !canSubmit || disabled
  }));
};

SubmitButton.displayName = 'SubmitButton';
SubmitButton.propTypes = {
  disabled: _propTypes.default.bool
};
var _default = SubmitButton;
exports.default = _default;